import { useCreate } from "@features/crud-table/hooks/use-create";
import { AutoForm } from "@features/form/components/auto-form";
import { useFormStore } from "@features/form/form.store";
import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { Separator } from "@shared/ui/separator";
import {
	Sheet,
	SheetClose,
	SheetContent,
	SheetDescription,
	SheetFooter,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "@shared/ui/sheet";
import { Plus } from "lucide-react";
import { FormattedMessage } from "react-intl";
import { z } from "zod";

export function FormSheet() {
	const { openFormSheet, setOpenFormSheet, mode, id } = useFormStore();
	const create = useCreate({ resource: "products" });

	const isCreateMode = mode === "create";

	const resourceName = "products";

	const resourceId = id;

	const handleSubmit = (values: any) => {
		if (isCreateMode) {
			create.mutate(values);
		}
	};

	return (
		<Sheet open={openFormSheet} onOpenChange={(open) => setOpenFormSheet(open)}>
			<SheetTrigger asChild>
				<Button className="gap-1.5 cursor-pointer">
					<Plus className="h-4 w-4" />
					<FormattedMessage id="table.create" defaultMessage="Create" />
				</Button>
			</SheetTrigger>
			<SheetContent className="w-full sm:max-w-md">
				<SheetHeader className="pb-2">
					<SheetTitle>
						{isCreateMode ? (
							<FormattedMessage id="table.creating" defaultMessage="Creating" />
						) : (
							<FormattedMessage id="table.editing" defaultMessage="Editing" />
						)}
					</SheetTitle>
					<SheetDescription>
						{isCreateMode ? (
							<FormattedMessage
								id="table.creating_description"
								defaultMessage="Adding a record to the {resource}  table"
								values={{
									resource: (
										<Badge variant="link" className="text-xs font-normal rounded-md">
											{resourceName}
										</Badge>
									),
								}}
							/>
						) : (
							<FormattedMessage
								id="table.editing_description"
								defaultMessage="Editing record {id} from the {resource} table"
								values={{
									resource: (
										<Badge variant="link" className="text-xs font-normal rounded-md">
											{resourceName}
										</Badge>
									),
									id: (
										<Badge variant="link" className="text-xs font-normal rounded-md">
											ID: {resourceId}
										</Badge>
									),
								}}
							/>
						)}
					</SheetDescription>
				</SheetHeader>
				<Separator />
				<div className="grid flex-1 auto-rows-min gap-6 px-4">
					<AutoForm schema={z.object({})} formName="form-sheet" onSubmit={handleSubmit} />
				</div>
				<Separator />
				<SheetFooter className="flex-row justify-end gap-2">
					<SheetClose asChild>
						<Button variant="outline">Cancel</Button>
					</SheetClose>
					<Button type="button" onClick={handleSubmit}>
						Add User
					</Button>
				</SheetFooter>
			</SheetContent>
		</Sheet>
	);
}
